'use client';

import type { Product } from '@packages/gql/generated/shopping/graphql';
import { Link } from '@packages/modules/src/Link/Link';
import { buildUrl } from '@packages/shared/src/utils/buildUrl/buildUrl';
import { useSearchParams } from 'next/navigation';
import { useIntl } from 'react-intl';

export type BackToProductCallToActionProps = {
  akl: Product['akl'];
};
export const BackToProductCallToAction = ({ akl }: BackToProductCallToActionProps) => {
  const { formatMessage } = useIntl();
  const searchParams = useSearchParams();
  const backToProductLink = buildUrl({ pathname: `/p/${akl}`, searchParams });

  return (
    <Link href={backToProductLink} className="flex items-center">
      <span className="icon-emp-arrow-medium-left inline-block size-3" />
      <span className="text-size-body-sm underline">
        {formatMessage({
          id: 'customer-ratings.back-to-product',
          defaultMessage: 'Zurück zum Produkt',
        })}
      </span>
    </Link>
  );
};
